module.exports = __webpack_public_path__ + "img/instagram.ced8ec57.svg";